import { EmbedContentView } from '@plone-collective/volto-embedcontent/EmbedContentView';
import { EmbedContentViewWrapper } from '@plone-collective/volto-embedcontent/EmbedContentViewWrapper';

const applyConfig = (config) => {
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    EmbedContent: EmbedContentView,
  };

  if (!config.components.EmbedContentViewWrapper) {
    config.registerComponent({
      name: 'EmbedContentViewWrapper',
      component: EmbedContentViewWrapper,
    });
  }

  if (__SERVER__) {
    const updadteMiddleware = require('./express-middleware').updadteMiddleware;

    config.settings.expressMiddleware = [
      ...config.settings.expressMiddleware,
      updadteMiddleware(),
    ];
  }

  return config;
};

export default applyConfig;
